var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ReactElementFactory, SurveyElementBase } from "survey-react-ui";
var SurveyNavigation = /** @class */ (function (_super) {
    __extends(SurveyNavigation, _super);
    function SurveyNavigation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onPropChangedHandler = function (sender, options) {
            if (_this.isRendering)
                return;
            var reactiveProps = [
                "showProgressBar",
                "progressBarType",
                "currentPageValue"
            ];
            if (reactiveProps.indexOf(options.name) < 0)
                return;
            var val = {};
            for (var i = 0; i < reactiveProps.length; i++) {
                var propName = reactiveProps[i];
                val[propName] = _this.survey[propName];
            }
            _this.setState(val);
        };
        return _this;
    }
    SurveyNavigation.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.setHandler();
    };
    SurveyNavigation.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.setHandler();
    };
    SurveyNavigation.prototype.setHandler = function () {
        if (!this.survey ||
            this.survey.onPropertyChanged.hasFunc(this.onPropChangedHandler))
            return;
        this.survey.onPropertyChanged.add(this.onPropChangedHandler);
    };
    SurveyNavigation.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (this.survey) {
            this.survey.onPropertyChanged.remove(this.onPropChangedHandler);
        }
    };
    Object.defineProperty(SurveyNavigation.prototype, "survey", {
        get: function () {
            return this.props.survey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyNavigation.prototype, "location", {
        get: function () {
            return this.props.location;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyNavigation.prototype, "isTop", {
        get: function () {
            return this.location == "top";
        },
        enumerable: false,
        configurable: true
    });
    SurveyNavigation.prototype.canRender = function () {
        return this.isTop
            ? this.survey.isShowProgressBarOnTop
            : this.survey.isShowProgressBarOnBottom;
    };
    SurveyNavigation.prototype.renderElement = function () {
        return ReactElementFactory.Instance.createElement(this.survey.getProgressTypeComponent(), { survey: this.survey, css: this.survey.css, isTop: this.isTop });
    };
    return SurveyNavigation;
}(SurveyElementBase));
export { SurveyNavigation };
